var rootFontSize = 16;
function remToPx(rem) {
  var rems = rem.substring(0, rem.length - 3);
  return +rems * rootFontSize;
}
function pxToRelative(px, baseFontSize, unitName) {
  if (!px || px === 0) return '0';
  return px / baseFontSize + unitName;
}
function pxToRem(px) {
  return pxToRelative(px, rootFontSize, 'rem');
}
function pxToEm(px) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : rootFontSize;
  return pxToRelative(px, base, 'em');
}
function limitDecimals(n) {
  return Math.round(n * 10000) / 10000;
}
function fractionToPercent(fraction) {
  if (fraction === 0) {
    return '0';
  }
  if (!fraction) {
    return undefined;
  }
  return "".concat(limitDecimals(fraction * 100), "%");
}
var _3px = pxToRem(3);
export { rootFontSize, _3px, remToPx, pxToRem, pxToEm, fractionToPercent };